import * as Yup from 'yup';

import { useContactSourceOptions } from '../../../useContactSourceOptions';

export const useSourceFilter = ({ setFilters }) => {
  const availableSourceOptions = useContactSourceOptions();

  // Transform options to have string values instead of arrays
  // This is required because FormMultiSelect only accepts string/number values
  const sourceOptions = availableSourceOptions.map((option) => ({
    label: option.label,
    value: JSON.stringify(option.value), // Serialize array to string
  }));

  const formSchema = Yup.object().shape({
    sources: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(), // Now expecting string instead of array
      }),
    ),
  });

  const onSubmit = ({ sources }) => {
    // Handle undefined or empty sources
    if (!sources || sources.length === 0) {
      setFilters({ sources: sources || [] });
      return;
    }

    // Transform back to original format with array values
    const transformedSources = sources.map((source) => {
      try {
        return {
          label: source.label,
          value: JSON.parse(source.value), // Deserialize string back to array
        };
      } catch (error) {
        return {
          label: source.label,
          value: Array.isArray(source.value) ? source.value : [], // Fallback to empty array
        };
      }
    });

    setFilters({ sources: transformedSources });
  };

  return {
    formSchema,
    onSubmit,
    sourceOptions,
  };
};
